// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2XLyx","options":"AnswerScale_options__2JHNo","selected":"AnswerScale_selected__AJS8f"};